import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-mixed-cart-clearance-question-dialog',
  templateUrl: './mixed-cart-clearance-question-dialog.component.html',
  styleUrls: ['./mixed-cart-clearance-question-dialog.component.scss']
})
export class MixedCartClearanceQuestionDialogComponent {
  constructor() {
  }

}
